import { render } from "./Scenario.vue?vue&type=template&id=63d41b4d"
import script from "./Scenario.vue?vue&type=script&lang=js"
export * from "./Scenario.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__